export default "__VITE_ASSET__805ac29b__"